export const user = state => state.user

export const userPreferences = (state) => {
  return user(state) && user(state).preferences
}

export const getSector = state => user(state) && user(state).sector

export const isApplyingFilter = state => user(state).applyingFilter